import { saveAs } from 'file-saver';
import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import rest from '../axios'; // sua instância axios
import Pagination from './Pagination';
export default function Historic() {
  const [filters, setFilters] = useState({
    admin: '',
    userName: '',
    journeyType: '',
    start_date: '',
    end_date: '',
    page: 1,
    limit: 10,
  });

  const [data, setData] = useState({
    items: [],
    total: 0,
    page: 1,
    limit: 10,
  });

  // Busca dados da API
  async function fetchData() {
    try {
      const response = await rest.get('/admin/tracking', { params: filters });
      setData((prev) => ({
        ...prev,
        items: response.data.userJourney,
        total: response.data.total,
      }));
    } catch (error) {
      console.error('Erro ao buscar histórico', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, [filters]);

  function handleChange(e) {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
      page: 1, // resetar página ao mudar filtro
    }));
  }

  function changePage(newPage) {
    if (newPage < 1 || newPage > Math.ceil(data.total / data.limit)) return;
    setFilters((prev) => ({ ...prev, page: newPage }));
  }

  function handleExport() {
    // Cria um array com os dados formatados para Excel
    const exportData = data.items.map(item => ({
      'Nome do usuário': item.first_name || '',
      'Sobrenome': item.last_name || '',
      'Nº do Usuário': item.phone || '',
      'Role': item.contact_type || '',
      'Condomínio': item.community_name || '',
      'Categoria Pesquisada': item.category || '',
      'Subcategoria Pesquisada': item.subcategory_name || '',
      'Jornada': item.journey || '',
      'Palavra Buscada': item.wordSearch || '',
      'Achou?': item.found || '',
      'Data da Busca': item.timeSearch ? new Date(item.timeSearch).toLocaleString() : '',
      'Número WhatsApp': item.whatsapp || '',
      'Nome do Prestador': item.provider_name || '',
    }));

    // Cria a planilha e o livro
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Histórico');

    // Gera o buffer
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Cria um Blob e força o download
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, 'historico.xlsx');
  }

  return (
    <>
      <h2 className="mb-4" style={{ fontWeight: '500', color: '#444' }}>Histórico Trackeamento</h2>

      <div className="container" style={{ maxWidth: '1500px' }}>
        <div className="card shadow-sm mb-4" style={{ padding: '20px' }}>
          <h5 className="mb-3" style={{ fontWeight: '600', color: '#555' }}>Filtrar Histórico de Jornadas</h5>

          <form
            className="row gx-3 gy-2 align-items-center"
            onSubmit={(e) => {
              e.preventDefault();
              fetchData();
            }}
          >
            <div className="col-sm-6 col-md-4">
              <label htmlFor="adminFilter" className="form-label" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                Filtrar por Admin
              </label>
              <select
                id="adminFilter"
                name="admin"
                className="form-select form-select-sm"
                value={filters.admin}
                onChange={handleChange}
              >
                <option value="">-- Todos --</option>
                <option value="1">Somente Admin</option>
                <option value="0">Sem Admin</option>
              </select>
            </div>

            <div className="col-sm-6 col-md-4">
              <label htmlFor="userNameFilter" className="form-label" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                Nome do Usuário
              </label>
              <input
                id="userNameFilter"
                type="text"
                name="userName"
                className="form-control form-control-sm"
                placeholder="Ex: Vinícius"
                value={filters.userName}
                onChange={handleChange}
              />
            </div>

            <div className="col-sm-6 col-md-4">
              <label htmlFor="journeyTypeFilter" className="form-label" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                Tipo de Jornada
              </label>
              <select
                id="journeyTypeFilter"
                name="journeyType"
                className="form-select form-select-sm"
                value={filters.journeyType}
                onChange={handleChange}
              >
                <option value="">-- Todos --</option>
                <option value="search">search</option>
                <option value="whatsapp">whatsapp</option>
              </select>
            </div>

            <div className="col-sm-6 col-md-3">
              <label htmlFor="startDateFilter" className="form-label" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                Data Início
              </label>
              <input
                id="startDateFilter"
                type="date"
                name="start_date"
                className="form-control form-control-sm"
                value={filters.start_date}
                onChange={handleChange}
              />
            </div>

            <div className="col-sm-6 col-md-3">
              <label htmlFor="endDateFilter" className="form-label" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                Data Fim
              </label>
              <input
                id="endDateFilter"
                type="date"
                name="end_date"
                className="form-control form-control-sm"
                value={filters.end_date}
                onChange={handleChange}
              />
            </div>

            <div className="col-12 d-flex gap-2 mt-3">
              <button
                type="submit"
                className="btn btn-success btn-sm flex-grow-0"
                style={{ minWidth: '140px' }}
              >
                Filtrar
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm flex-grow-0"
                style={{ minWidth: '160px' }}
                onClick={handleExport}
              >
                Exportar para Excel
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Tabela */}
      <div className="table-responsive container" style={{ maxWidth: '1500px' }}>
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th>Nome do usuário</th>
              <th>Sobrenome</th>
              <th>Nº do Usuário</th>
              <th>Role</th>
              <th>Condomínio</th>
              <th>Categoria Pesquisada</th>
              <th>Subcategoria Pesquisada</th>
              <th>Jornada</th>
              <th>Palavra Buscada</th>
              <th>Achou?</th>
              <th>Data da Busca</th>
              <th>Número WhatsApp</th>
              <th>Nome do Prestador</th>
            </tr>
          </thead>
          <tbody>
            {data.items.length === 0 ? (
              <tr><td colSpan="13" className="text-center">Nenhum registro encontrado</td></tr>
            ) : (
              data.items.map(journey => (
                <tr key={journey.id}>
                  <td>{journey.user?.first_name || 'Visitante'}</td>
                  <td>{journey.user?.last_name || '—'}</td>
                  <td>{journey.user?.phone || '—'}</td>
                  <td>{journey.user?.contact_type || '—'}</td>
                  <td>{journey.user?.community?.name || '—'}</td>
                  <td>{journey.subcategory?.category?.name || '—'}</td>
                  <td>{journey.subcategory?.name || '—'}</td>
                  <td>{journey.journey || '—'}</td>
                  <td>{journey.wordSearch || '—'}</td>
                  <td>{journey.found || '—'}</td>
                  <td>{journey.timeSearch ? new Date(journey.timeSearch).toLocaleString() : '—'}</td>
                  <td>{journey.whatsapp || '—'}</td>
                  <td>{journey.provider?.name || '—'}</td>
                </tr>
              )
              )
            )}
          </tbody>
        </table>
      </div>

      {/* Paginação */}
      <Pagination page={filters.page} total={data.total} limit={filters.limit} changePage={changePage} />
    </>
  );
}
